import React from "react";
import JournalEntryDrawer from "../../../components/common/jouralEntryDrawer/journalEntryDrawer";
import useLogAccessEvent from "../../../hooks/useLogAccessEvent";
import { AccessEventIndividualDetails } from "../../../services/types/accessEventTypes";

export type UserJournalDrawerProps = {
    userId: string;
    email: string;
    open: boolean;
    onClose: () => void;
    onSave: () => void;
};

const UserJournalDrawer: React.FC<UserJournalDrawerProps> = (props) => {
    const { logEvent } = useLogAccessEvent();

    const catData = { userId: props.userId, email: props.email };

    function saveEntry() {
        const evtData: AccessEventIndividualDetails = {
            imKey: props.userId,
            email: props.email,
        };
        logEvent("UserJournalEntryCreated", evtData);
        props.onSave();
    }

    return (
        <JournalEntryDrawer
            journalCategory={5}
            journalCategoryData={[JSON.stringify(catData)]}
            journalHistory={[]}
            open={props.open}
            onClose={() => props.onClose()}
            onSave={() => saveEntry()}
            onSaveError={(msg: string) => console.log(msg)}
        />
    );
};

export default UserJournalDrawer;
